import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, FormControlLabel, FormHelperText, Switch } from '@mui/material'
import { Controller } from 'react-hook-form'
import T from 'T'

const switchSx = theme => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: theme.palette.success.main,
    '&:hover': { bgcolor: `${theme.palette.success.main}14` },
    '& + .MuiSwitch-track': {
      backgroundColor: theme.palette.success.light,
      opacity: 1,
    },
  },
  '& .MuiSwitch-switchBase:not(.Mui-checked)': {
    color: theme.palette.warning.main,
    '& + .MuiSwitch-track': {
      backgroundColor: theme.palette.warning.light,
      opacity: 1,
    },
  },
})

const ServiceActiveSwitch = ({ control, onChange, rules, error, helperText, disabled = false }) => (
  <Controller
    control={control}
    name="deactivate"
    rules={rules}
    render={({ field }) => {
      const { value: deactivate, onChange: onChangeField, onBlur } = field
      const isActive = !deactivate

      const handleChange = e => {
        const newDeactivate = !e.target.checked
        onChangeField(newDeactivate)
        if (onChange) onChange(newDeactivate)
        onBlur()
      }

      return (
        <FormControl>
          <FormControlLabel
            disabled={disabled}
            control={<Switch checked={isActive} onChange={handleChange} sx={switchSx} />}
            label={isActive ? T.ACTIVE : T.DEACTIVATED}
            labelPlacement="start"
            sx={{ color: 'text.secondary', mr: 0 }}
          />
          {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
        </FormControl>
      )
    }}
  />
)

ServiceActiveSwitch.propTypes = {
  control: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  rules: PropTypes.object,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
}

export default ServiceActiveSwitch
